import React from "react";
import DatePicker from "react-datepicker";
import { useFormikContext } from "formik";

type TParams = { readonly name: string, readonly value: Date, readonly onBlur: any, readonly disabled: boolean };

function handleDateChangeRaw(e: any) {
  e.preventDefault();
}

function DatePickerField({ name, value, onBlur, disabled }: TParams) {
  const { setFieldValue } = useFormikContext();

  const years = Array.from(new Array(50).keys()).map(i => 2000 + i);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  return (
    <DatePicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => (
        <div
          style={{
            margin: 10,
            display: "flex",
            justifyContent: "center"
          }}
        >
          <button type="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(+value)}
          >
            {years.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button type="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      dateFormat="MM/dd/yyyy"
      autoComplete="off"
      name={name}
      selected={value}
      onChange={(val: Date | null) => {
        setFieldValue(name, val);
      }}
      onChangeRaw={handleDateChangeRaw}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
};

export default DatePickerField;
